import { AppModules } from 'appContainer/types';
import { PathRouteContent, RouteNode } from 'router/declarative/routeNode';

export const routes = {
  path: '/audit-log',
  title: 'Audit log',
  appModule: AppModules.AUDIT_LOG,
  content: async (): PathRouteContent =>
    (await import('./AuditLogContainer')).AuditLogContainer,
  children: [],
} as const satisfies RouteNode;
